var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueOutlineInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99896 0.766602C11.9938 0.766602 15.2323 4.00508 15.2323 7.99994C15.2323 11.9948 11.9938 15.2333 7.99896 15.2333C4.0041 15.2333 0.765625 11.9948 0.765625 7.99994C0.765625 4.00508 4.0041 0.766602 7.99896 0.766602ZM7.99896 1.89993C4.63002 1.89993 1.89896 4.631 1.89896 7.99994C1.89896 11.3689 4.63002 14.0999 7.99896 14.0999C11.3679 14.0999 14.099 11.3689 14.099 7.99994C14.099 4.631 11.3679 1.89993 7.99896 1.89993ZM7.99896 7.43327C8.28785 7.43327 8.52624 7.64944 8.56121 7.92885L8.56563 7.99994V10.6666C8.56563 10.9796 8.31192 11.2333 7.99896 11.2333C7.71007 11.2333 7.47167 11.0171 7.43671 10.7377L7.43229 10.6666V7.99994C7.43229 7.68697 7.686 7.43327 7.99896 7.43327ZM8.00563 4.7666C8.31859 4.7666 8.57229 5.02031 8.57229 5.33327C8.57229 5.62216 8.35612 5.86055 8.07671 5.89552L7.99896 5.89993C7.686 5.89993 7.43229 5.64623 7.43229 5.33327C7.43229 5.04438 7.64847 4.80598 7.92788 4.77102L8.00563 4.7666Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueOutlineInfo);
export default __webpack_public_path__ + "static/media/blue-outline_info.9dfcbea9ef3bcc202a73f7932581a4af.svg";
export { ForwardRef as ReactComponent };